import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { saveAs } from 'file-saver';
import {
  HQ_REST_DUE_HEADER_IMG,
  MODAL_CLOSE,
  CLOUD_DOWNLOAD,
} from 'src/defaultImages.js';
import { CollectionInfrastructureModalService } from '../../collection-infrastructure-modal.service';
import { UtilService } from 'src/app/util/util.service';
import { MessageService } from 'src/app/common/services/message.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { CollectionInfrastructureService } from '../../collection-infrastructure.service';
import { FormaterService } from 'src/app/common/services/formater.service';
import {
  CLIENT_ID,
  PAYMENT_DESCRIPTON,
} from '../../collection-infrastructure.enums';

@Component({
  selector: 'app-hq-restaurants-due-modal',
  templateUrl: './hq-restaurants-due-modal.component.html',
  styleUrls: ['./hq-restaurants-due-modal.component.css'],
})
export class HqRestaurantsDueModalComponent implements OnInit {
  images: any = {
    HQ_REST_DUE_HEADER_IMG,
    MODAL_CLOSE,
    CLOUD_DOWNLOAD,
  };
  checked: any = {};
  totalDue: any = {
    value: 0,
    text: '0.00',
  };
  @Input() negativeCurrentBalance: any;
  currency: string;

  constructor(
    private _modalRef: NzModalRef,
    private _ciModalService: CollectionInfrastructureModalService,
    private _utilService: UtilService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _msg: MessageService,
    private _currService: CurrencyService,
    private _formater: FormaterService
  ) {
    this.currency = this._currService.getCurrency();
  }

  ngOnInit() {
    this.createCheckedObject();
  }

  createCheckedObject() {
    const checkedRes = {};
    for (const item of this.negativeCurrentBalance.restaurants) {
      checkedRes[(item || {}).restaurantId] = false;
    }
    this.checked = checkedRes;
  }

  dismissModal(): void {
    this._modalRef.close();
  }

  calculateTotalDue() {
    let total = 0;

    // Iterate over the restaurants
    for (const item of this.negativeCurrentBalance.restaurants) {
      if (this.checked[item.restaurantId]) {
        total += item.balance;
      }
    }

    this.totalDue = {
      value: total,
      text: this._formater.formatNo(total),
    };
  }

  async downloadNegativeCurrentBalanceReport(restaurantId?: string) {
    const hqId = this._utilService.getHqId();
    const response: any =
      await this._collectionInfraService.downloadNegativeCurrentBalanceReport(
        hqId,
        restaurantId
      );
    if ((response || {}).statusCode === 200) {
      if ((response || {}).data) {
        const filename = this._utilService.generateFileName(
          (response || {}).data
        );
        saveAs((response || {}).data, filename);
        this._msg.showSuccess((response || {}).message);
      } else {
        this._msg.showError((response || {}).message);
      }
    }
  }

  redirectToPaymentPage(options: any = {}) {
    const { restaurants = [] } = this.negativeCurrentBalance || {};

    const paymentPayload = restaurants.reduce(
      (acc, { restaurantId, balance }) => {
        if (options.payAll) {
          acc.push({
            restaurant_id: restaurantId,
            amount: Math.abs(balance),
          });
        } else if (options.multiple && this.checked[restaurantId]) {
          acc.push({
            restaurant_id: restaurantId,
            amount: Math.abs(balance),
          });
        } else if (options.single && options.restaurantId === restaurantId) {
          acc.push({
            restaurant_id: restaurantId,
            amount: Math.abs(balance),
          });
        }
        return acc;
      },
      []
    );

    this._ciModalService.openPaymentMethodModal({
      paymentPayload,
      return_url: window.location.href,
      client_id: CLIENT_ID.CURRENT_BALANCE_PAYMENT,
      payment_description: PAYMENT_DESCRIPTON.CURRENT_BALANCE_PAYMENT,
    });
  }
}
